/**
 * @desc 财务画像-财务舞弊-流动负债
*/
import style from './echartsHeight.scss';
import React, { PureComponent }  from 'react';
import NoData from '../../../../common/noData/NoData';
import BBDPie from '../../../../common/echarts/BBDPie';
import { Table, Row, Col } from 'antd';
import { assetLiabilit } from '../../../../../services/financialPicture/baseInfo';
import { netProfit } from '../../../../../services/financialPicture/fraudAnalysis';
import { commonRequest, commonPieOption } from '../../../common/commons';
import { isNotEmpty } from '../../../../../utils/util';

export default class CurrentLiabilities extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            tableData: [],
            pieData: {
                circulatasset: '流动资产构成',
                circulatdebt: '流动负债构成',
                fixeddebt: '非流动负债构成',
                bankDef: '银行存款',
                totalCurrliab: '流动负债',
                totalNoncliab: '非流动负债'
            }
        };
    }

    componentDidMount() {
        this.assetLiabilitPort();
        this.netProfitPort();
    }

    // 饼图数据
    assetLiabilitPort = () => {
        assetLiabilit(commonRequest()).then(data => {
            data = data || {};
            this.setState({
                data: this.allDataFn(data || {})
            });
        }).catch(() => {
            this.setState({
                data: []
            });
        });
    };

    allDataFn = (data) => {
        const { pieData } = this.state;
        let allData = [];
        for (let d in data) {
            if (d !== 'fixedasset') {
                allData.push({ name: pieData[d], value: data[d] });
            }
        }
        return allData;
    };

    // 表格数据
    netProfitPort = () => {
        const { id } = this.props;
        netProfit(commonRequest({ id })).then(data => {
            data = data || {};
            this.setState({
                tableData: data || {}
            });
        }).catch(() => {
            this.setState({
                tableData: []
            });
        });
    }

    getColumns = () => {
        return [{
            title: '',
            dataIndex: 'reportYear'
        }, {
            title: '银行存款',
            dataIndex: 'bankDef'
        }, {
            title: '流动负债',
            dataIndex: 'totalCurrliab'
        }, {
            title: '非流动负债',
            dataIndex: 'totalNoncliab'
        }];
    };

    render() {
        const { data, tableData } = this.state;
        let legend = false, center = ['50%', '48%'],
            color = [
                '#F8B551', '#F99248', '#73CDFC',
                '#90BBF8', '#2365C4', '#534FCF',
                '#AAA7F9', '#ACD598', '#6CBA52',
                '#097C25', '#ED726C'
            ];
        return (
            <div>
                <div className="margin-top-40">
                    <Table
                        bordered
                        rowKey="reportYear"
                        dataSource={tableData}
                        columns={this.getColumns()}
                        pagination={false}
                    />
                </div>
                <div className="margin-top-40">
                    <Row>
                        {data.map(item => (
                            <Col span={6} offset={2} key={item.name}>
                                <p className="align-c wrap-title">{item.name}</p>
                                {isNotEmpty(item.value) ?
                                    <div className={style.currentLiabilities}>
                                        <BBDPie option={commonPieOption(legend, center, color, item.value)} />
                                    </div> : <NoData />
                                }
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/CurrentLiabilities.jsx